import React from "react";
import helperStyles from "@src/components/helpers.module.scss";

const DoubleCheckIcon = () => {
	return (
		<div className={helperStyles.iconContainer}>
			<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
				<path d="M12.0002 4L4.66683 11.3333L1.3335 8" stroke="#4E9D3A" strokeLinecap="round" strokeLinejoin="round" />
				<path
					d="M14.6665 6.6665L9.6665 11.6665L8.6665 10.6665"
					stroke="#4E9D3A"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
			</svg>
		</div>
	);
};

export default DoubleCheckIcon;
